import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/NewsDetail.scss';
import { newsData } from '../../data/newsData';

const NewsList = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="NewsDetail">
      <Header />
      <main>
        <section id="news" className="news">
          <div className="section-content">
            <h2 className="section-title">News</h2>
            <div className="news-grid">
              {newsData.map(news => (
                <Link to={`/news/${news.id}`} className="news-card" key={news.id}>
                  <div className="news-image">
                    <img src={news.img} alt={news.title} />
                  </div>
                  <div className="news-content">
                    <div className="news-meta">
                      <span>{news.author}</span>
                      <span>{news.date}</span>
                      <span>{news.category}</span>
                    </div>
                    <h3 className="news-title">{news.title}</h3>
                    <p className="news-excerpt">{news.excerpt}</p>
                    <div className="read-more">Read More</div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default NewsList; 